import { render, staticRenderFns } from "./bindOwnerShops.vue?vue&type=template&id=0e23d08a"
import script from "./bindOwnerShops.vue?vue&type=script&lang=js"
export * from "./bindOwnerShops.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports